import { render, staticRenderFns } from "./MainNavigationDrawer.vue?vue&type=template&id=18a3586b&scoped=true"
import script from "./MainNavigationDrawer.vue?vue&type=script&lang=ts"
export * from "./MainNavigationDrawer.vue?vue&type=script&lang=ts"
import style0 from "./MainNavigationDrawer.vue?vue&type=style&index=0&id=18a3586b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a3586b",
  null
  
)

export default component.exports